import { Box, Container, Typography } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import GoogleCalendarIntegration from '../components/integrations/GoogleCalendarIntegration';
import OutlookCalendarIntegration from '../components/integrations/OutlookCalendarIntegration';
import { useGetOrganizationIntegrations } from '../services/react-query/integrations/useGetOrganizationIntegrations';
import { headerProps, headerTypographyProps } from '../styles/sxStyling';
import { CalendarPartner } from '../types/Integration';

export default function Integrations() {
  const { data: integrationResponse, isLoading } = useGetOrganizationIntegrations({});
  const googleIntegration = _.find(integrationResponse?.data, { partner: CalendarPartner.GOOGLE });
  const outlookIntegration = _.find(integrationResponse?.data, { partner: CalendarPartner.OUTLOOK });

  return (
    <Container>
      <Box sx={headerProps}>
        <Typography {...headerTypographyProps}>Integrations</Typography>
      </Box>
      <Box display="flex" gap={4}>
        <GoogleCalendarIntegration integration={googleIntegration} isLoading={isLoading} />
        <OutlookCalendarIntegration integration={outlookIntegration} isLoading={isLoading} />
      </Box>
    </Container>
  );
}
